import React, { useEffect, useRef } from 'react';
import { useWallet } from '../../context/WalletContext';
import { useNotify } from '../../context/NotificationContext';
import Button from '../common/Button';
import FullScreenLoader from '../loader/FullScreenLoader';

// Silently attempts the switch when connected on the wrong network,
// and shows an actionable overlay if the switch is rejected/fails.
export default function NetworkGuard({ children }) {
  const { account, isCorrectNetwork, switching, switchNetworkNow } = useWallet();
  const notify = useNotify();
  const attemptedRef = useRef(false);

  useEffect(() => {
    if (!account) { attemptedRef.current = false; return; }
    if (isCorrectNetwork) { attemptedRef.current = false; return; }
    if (attemptedRef.current) return;
    attemptedRef.current = true;
    (async () => {
      try {
        await switchNetworkNow();
        notify.success('Network switched');
      } catch (e) {
        notify.error('Wrong network', 'Please approve the network switch in your wallet.');
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account, isCorrectNetwork]);

  return (
    <>
      {children}
      {switching && <FullScreenLoader message="Switching network…" sub="Approve in your wallet" />}
      {account && !isCorrectNetwork && !switching && (
        <div className="tx-overlay">
          <div style={{ maxWidth: 320, textAlign: 'center' }}>
            <div style={{ fontSize: 44, marginBottom: 12 }}>⚠️</div>
            <div className="msg" style={{ fontSize: 17 }}>Wrong Network</div>
            <div className="sub" style={{ marginBottom: 18 }}>
              Please switch your wallet to the correct network to continue.
            </div>
            <Button block onClick={async () => {
              try { await switchNetworkNow(); notify.success('Network switched'); }
              catch (e) { notify.error('Switch failed', e && e.message); }
            }}>
              Switch Network
            </Button>
          </div>
        </div>
      )}
    </>
  );
}
